import {Action, Dispatch} from "redux";
import {FacetedFilters, IResearchPagination} from "../../model/ResearchPageState.model";

export enum ManagerStrategiesActionTypes {
    CLEAR_MANAGER_STRATEGIES = "CLEAR_MANAGER_STRATEGIES",
    UPDATE_MANAGER_STRATEGIES_FACETED_FILTERS = "UPDATE_MANAGER_STRATEGIES_FACETED_FILTERS",
    UPDATE_MANAGER_STRATEGIES_SEARCH_TEXT = "UPDATE_MANAGER_STRATEGIES_SEARCH_TEXT",
    UPDATE_MANAGER_STRATEGIES_PAGINATION = "UPDATE_MANAGER_STRATEGIES_PAGINATION",
    SET_MANAGER_STRATEGIES_SCROLL_TO = "SET_MANAGER_STRATEGIES_SCROLL_TO",
    CLEAR_ALL_MANAGER_STRATEGIES_FILTERS = "CLEAR_ALL_MANAGER_STRATEGIES_FILTERS",
}

export const clearStrategiesAction = () => {
    return (dispatch: Dispatch<Action<ManagerStrategiesActionTypes>>) => {
        dispatch({type: ManagerStrategiesActionTypes.CLEAR_MANAGER_STRATEGIES, payload: {}});
    };
};

export const updateFacetedFiltersAction = (managerId: number, facetedFilters: FacetedFilters) => {
    const payload = {managerId, facetedFilters};
    return (dispatch: Dispatch<Action<ManagerStrategiesActionTypes>>) => {
        dispatch({type: ManagerStrategiesActionTypes.UPDATE_MANAGER_STRATEGIES_FACETED_FILTERS, payload});
    };
};

export const updateSearchTextAction = (managerId: number, searchText: string) => {
    const payload = {managerId, searchText};
    return (dispatch: Dispatch<Action<ManagerStrategiesActionTypes>>) => {
        dispatch({type: ManagerStrategiesActionTypes.UPDATE_MANAGER_STRATEGIES_SEARCH_TEXT, payload});
    };
};

export const updatePaginationAction = (managerId: number, pagination: IResearchPagination) => {
    const payload = {managerId, pagination};
    return (dispatch: Dispatch<Action<ManagerStrategiesActionTypes>>) => {
        dispatch({type: ManagerStrategiesActionTypes.UPDATE_MANAGER_STRATEGIES_PAGINATION, payload});
    };
};

export const setScrollToBackstopAction = (managerId: number, backstopId: number) => {
    const payload = {managerId, scrollToBackstopId: backstopId};
    return (dispatch: Dispatch<Action<ManagerStrategiesActionTypes>>) => {
        dispatch({type: ManagerStrategiesActionTypes.SET_MANAGER_STRATEGIES_SCROLL_TO, payload});
    };
};

export const clearAllFiltersAction = (managerId: number) => {
    const payload = {managerId};
    return (dispatch: Dispatch<Action<ManagerStrategiesActionTypes>>) => {
        dispatch({type: ManagerStrategiesActionTypes.CLEAR_ALL_MANAGER_STRATEGIES_FILTERS, payload});
    };
};

export default {
    clearStrategiesAction,
    updateFacetedFiltersAction,
    updateSearchTextAction,
    updatePaginationAction,
    setScrollToBackstopAction,
    clearAllFiltersAction,
};
